<div class="member-portal-nav-bar">
    <div class="my-account">MY ACCOUNT</div>
    <div fxLayout="column" class="content">
        <a [ngClass]="{'current': current === 'My Personal Setting'}" href="/#/member-portal">My Personal Settings</a>
        <a [ngClass]="{'current': current === 'Order History'}" href="/#/member-portal/order-history">Order History</a>
        <a [ngClass]="{'current': current === 'Address Book'}" href="/#/member-portal/address-book">Address Book</a>
    </div>
</div>